import type { FaireProductEntity } from "../../entity_types/product";

export const p_7kamwc83gp: FaireProductEntity = {
  token: "p_7kamwc83gp",
  type: "product",
  name: "Mohawk St. Luxury Candle | Musk, Amber & Sandalwood",
  brandToken: "b_rp9e5zdxjc",
  brandName: "Wilkin & May",
  imageUrl:
    "https://cdn.faire.com/fastly/98365011eb207b80df800fff038b584bb831a16fb28116d22e36032f42e0c3b4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21f6ae1c03ad72b0b6d7034750587276c4d23a13bf80db1f6f1122a2cbc4e664.jpeg",
    "https://cdn.faire.com/fastly/89ed06ff96ade09d048f40aab58ef6fa6203c8300cbc7604f99e4c836fcf6080.png",
    "https://cdn.faire.com/fastly/c08efa1719e21799679f3a11e70e1b02ef86abdc7bab8c5ded768073d4925bd4.jpeg",
  ],
  priceDollars: 24,
  description:
    "The kind of fragrance that becomes part of your everyday.\n\nMohawk St. is warm, familiar, and quietly magnetic. Soft musk and sandalwood create its unmistakable foundation, while subtle spice and amber bring depth without ever feeling heavy. It's the fragrance you'll reach for again and again—effortless enough for every day, distinctive enough to become your signature.\n\nEvery detail is designed to feel intentional: hand-poured in small batches, a clean coconut wax blend for an elegant burn, and a vessel meant to live on long after the flame. Even the wax itself is skin-safe, melting into a balm you can carry beyond the room. \n\nDetails:\n\n- Hand-poured in Ojai, California in small batches\n- Clean-burning coconut wax blend\n- Skin-safe wax doubles as a nourishing balm\n- 40+ hour burn time\n- Lead-free cotton wick\n- Reusable glass vessel\n- Phthalate-free, paraben-free and cruelty-free\n- Sustainable, biodegradable wax and packaging\n- Fragrance oils infused with natural botanicals\n- Ideal for gift shops, home decor stores, men’s gifting, self-care displays and boutique home \nfragrance retailers\n\nLuxury positioning: warm, familiar, amber, musky, refined and gift-worthy.",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:31.992Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
